import styled from '@emotion/styled'

export const StyleUniversalBannerWrapper = styled.div<{ bgColor?: string }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 20px;
  background-color: ${(props: any) => props.bgColor || '#e6f5fc'};
  border-radius: 14px;
  align-items: center;
  @media (max-width: 480px) {
    padding: 20px;
  }
`

export const StyleTextButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 4;
`

export const StyleImage = styled.img`
  width: 300px;
  height: 180px;
  object-fit: contain;
  transform: translateX(50px);
  /* transform: translateY(-30px);
  position: absolute;
  object-fit: contain;
  right: 0;
  */
  @media (max-width: 480px) {
    display: none;
  }
  @media (max-width: 768px) {
    width: 300px;
    height: 180px;
  }
`
